import { render } from "./SystemMessage1.vue?vue&type=template&id=6c6bfd62"
import script from "./SystemMessage1.vue?vue&type=script&lang=js"
export * from "./SystemMessage1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/SystemMessage1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6bfd62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6bfd62', __exports__)) {
    api.reload('6c6bfd62', __exports__)
  }
  
  module.hot.accept("./SystemMessage1.vue?vue&type=template&id=6c6bfd62", () => {
    api.rerender('6c6bfd62', render)
  })

}


export default __exports__